import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '@/views/home-page';
import TasksPage from '@/views/tasks-page';

Vue.use(Router);

const router = new Router({
    //mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        // { path: '/', redirect: '/defaultview' }, // @todo

        // appConfig.defaultRoute
        {path: '/', name: 'home', component: HomePage},
        {path: '/tasks', name: 'tasks', component: TasksPage},
        //{path: '/about', name: 'about', component: () => import(/* webpackChunkName: "home-page" */ './views/home-page')}
        {path: '/math/lessons', name: 'math-lessons', component: () => import(/* webpackChunkName: "math-lessons-page" */ './views/math/math-lessons-page')},
        {path: '/math/topics', name: 'math-topics', component: () => import(/* webpackChunkName: "math-topics-page" */ './views/math/math-topics-page')},
        {path: '/math/topics/:id', name: 'math-topic', component: () => import(/* webpackChunkName: "math-topic-page" */ './views/math/math-topic-page')},

        // { path: '*', component: NotFoundComponent } // @todo
    ]
});

//router.replace({ path: '*', redirect: '/' });

export default router;
